var _g, _g2, _path, _g3, _g4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoTransferIllustration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 165,
    viewBox: "0 0 170 165",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5202_13064)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.83 94.2361C139.686 95.8931 139.847 98.7406 138.19 100.596L107.839 134.587C106.182 136.442 103.335 136.603 101.479 134.947L30.752 71.7925C28.8963 70.1355 28.7352 67.288 30.3922 65.4323L60.743 31.4419C62.4 29.5862 65.2475 29.4252 67.1032 31.0821L137.83 94.2361Z",
    fill: "#9EBCFF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_5202_13064)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142.81 69.0103L142.81 63.3046C142.81 58.0051 138.514 53.709 133.214 53.709L37.2581 53.709C31.9586 53.709 27.6625 58.0051 27.6625 63.3046L27.6625 69.7881C27.6625 71.5068 29.0559 72.9002 30.7746 72.9002C32.4934 72.9002 33.8867 74.2935 33.8867 76.0123L33.8867 90.017C33.8867 91.7357 32.4934 93.1291 30.7746 93.1291C29.0559 93.1291 27.6625 94.5224 27.6625 96.2412L27.6625 102.725C27.6625 108.024 31.9587 112.32 37.2582 112.32L133.214 112.32C138.514 112.32 142.81 108.024 142.81 102.725L142.81 97.0189C142.81 94.8706 141.069 93.1291 138.92 93.1291C136.772 93.1291 135.03 91.3875 135.03 89.2392L135.03 76.79C135.03 74.6417 136.772 72.9002 138.92 72.9002C141.069 72.9002 142.81 71.1586 142.81 69.0103Z",
    fill: "url(#paint0_linear_5202_13064)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.9873 57.3432L62.9873 54.4902L64.7891 54.4902L64.7891 57.3432C64.7891 57.8408 64.3857 58.2441 63.8882 58.2441C63.3906 58.2441 62.9873 57.8408 62.9873 57.3432ZM63.8882 62.1482C64.3857 62.1482 64.7891 62.5516 64.7891 63.0491L64.7891 68.7551C64.7891 69.2526 64.3857 69.656 63.8882 69.656C63.3906 69.656 62.9873 69.2526 62.9873 68.7551L62.9873 63.0491C62.9873 62.5516 63.3906 62.1482 63.8882 62.1482ZM63.8882 73.5601C64.3857 73.5601 64.7891 73.9635 64.7891 74.461L64.7891 80.1669C64.7891 80.6645 64.3857 81.0678 63.8882 81.0678C63.3906 81.0678 62.9873 80.6645 62.9873 80.1669L62.9873 74.461C62.9873 73.9635 63.3906 73.5601 63.8882 73.5601ZM63.8882 84.972C64.3857 84.972 64.7891 85.3753 64.7891 85.8729L64.7891 91.5788C64.7891 92.0764 64.3857 92.4797 63.8882 92.4797C63.3906 92.4797 62.9873 92.0764 62.9873 91.5788L62.9873 85.8729C62.9873 85.3753 63.3906 84.972 63.8882 84.972ZM63.8882 96.3838C64.3857 96.3838 64.7891 96.7872 64.7891 97.2847L64.7891 102.991C64.7891 103.488 64.3857 103.892 63.8882 103.892C63.3906 103.892 62.9873 103.488 62.9873 102.991L62.9873 97.2847C62.9873 96.7872 63.3906 96.3838 63.8882 96.3838ZM63.8882 107.796C64.3857 107.796 64.7891 108.199 64.7891 108.697L64.7891 111.55L62.9873 111.55L62.9873 108.697C62.9873 108.199 63.3906 107.796 63.8882 107.796Z",
    fill: "white"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5202_13064)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.962 91.529C99.0683 93.3367 96.5679 94.4359 93.8267 94.4359C87.9158 94.4359 83.124 89.3247 83.124 83.0197C83.124 76.7147 87.9158 71.6035 93.8267 71.6035C96.5679 71.6035 99.0683 72.7027 100.962 74.5104C102.855 72.7027 105.356 71.6035 108.097 71.6035C114.008 71.6035 118.8 76.7147 118.8 83.0197C118.8 89.3247 114.008 94.4359 108.097 94.4359C105.356 94.4359 102.855 93.3367 100.962 91.529Z",
    fill: "#C5D2FF"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_5202_13064)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.432 28.0889C149.103 28.3844 158.474 37.9388 158.475 49.6816L158.468 50.2393C158.172 61.9111 148.617 71.2822 136.874 71.2822L136.317 71.2754C124.831 70.9846 115.572 61.726 115.281 50.2393L115.274 49.6816C115.275 37.7526 124.945 28.0822 136.874 28.082L137.432 28.0889ZM127.142 62.6328C129.851 64.6725 133.221 65.8817 136.874 65.8818C145.821 65.8818 153.074 58.6287 153.074 49.6816C153.074 46.0289 151.865 42.6588 149.825 39.9492L127.142 62.6328ZM136.874 33.4824C127.927 33.4826 120.675 40.7349 120.675 49.6816C120.675 53.0257 121.688 56.1333 123.424 58.7139L145.906 36.2314C143.326 34.4953 140.218 33.4824 136.874 33.4824Z",
    fill: "#4C95FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5202_13064",
    x: 27.4458,
    y: 28.1357,
    width: 117.295,
    height: 113.361,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.8018,
    dy: 1.8018
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.8018
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.372549 0 0 0 0 0.52549 0 0 0 0 0.74902 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5202_13064"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5202_13064",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_5202_13064",
    x: 25.8608,
    y: 51.9072,
    width: 122.355,
    height: 65.8185,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.8018,
    dy: 1.8018
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.8018
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.372549 0 0 0 0 0.52549 0 0 0 0 0.74902 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5202_13064"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5202_13064",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_5202_13064",
    x: 112.874,
    y: 26.882,
    width: 48.0002,
    height: 47.9992,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5202_13064"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5202_13064",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5202_13064",
    x1: 142.81,
    y1: 83.0147,
    x2: 27.6625,
    y2: 83.0147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCE9F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DAE4FD"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5202_13064"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35.6756,
    height: 22.8324,
    fill: "white",
    transform: "translate(83.124 71.6035)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoTransferIllustration);
export default __webpack_public_path__ + "static/media/noTransferIllustration.bfa470563c1f95595d4d24c048fe5dbb.svg";
export { ForwardRef as ReactComponent };